function Hero({ config }) {
  return (
    <div className="bg-slate-100 relative overflow-hidden">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 pt-6 pb-0">
        {config.show_hero_catch && (
          <div className="flex justify-center">
            <span className="inline-flex items-center gap-x-2 bg-white border border-gray-200 text-xs text-gray-800 sm:text-sm lg:text-base p-1 ps-3 pe-3 rounded-full transition hover:border-gray-300">
              保険証の<u>記号・番号</u>、<u>保険者番号</u>はどこで確認できるの？
            </span>
          </div>
        )}

        <div className="mt-4 lg:mt-8 mb-3 max-w-4xl text-center mx-auto">
          <h1 className="block font-bold text-gray-800 text-3xl md:text-5xl lg:text-6xl">
            <span className="text-blue-700">
              {config.title_head}
            </span>
            {config.title_tail}
          </h1>
        </div>

        {config.show_hero_lead && (
          <div className="mb-4 md:mb-0 bg-white rounded-lg mt-8 p-4 max-w-3xl text-center mx-auto">
            <p className="leading-8 tracking-wide">
              従来の健康保険証に記載されていた
              <strong>
                <u>記号・番号</u>
              </strong>
              や
              <strong>
                <u>保険者番号</u>
              </strong>
              などの情報は、
              <strong>
                <u>マイナポータル</u>
              </strong>
              {(config.show_notification || config.show_newcard) && (
                <span>や</span>
              )}
              {config.show_notification && (
                <strong>
                  <u>資格情報のお知らせ</u>
                </strong>
              )}
              {(config.show_notification || config.show_newcard) && (
                <span>、</span>
              )}
              {config.show_newcard && (
                <strong>
                  <u>資格確認書</u>
                </strong>
              )}
              で確認することができます。
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Hero;
